<template>
  <div v-if="report.includes_director_reports">
    <div v-if="officer.otherappointments.length > 0 && this.numberOfActiveOtherDirectorships > 0">
      <h5>Other Active Directorships ({{ numberOfActiveOtherDirectorships }})</h5>
      <div
        v-for="otherappointment in openOtherAppointments"
        :key="otherappointment.id"
        class="panel panel-default summaryPanel"
      >
        <other-directorship :otherappointment="otherappointment"></other-directorship>
      </div>
    </div>
    <div v-else>
      <h5>Other Active Directorships ({{ numberOfActiveOtherDirectorships }})</h5>
      No active directorships of other companies found.
    </div>
  </div>
</template>

<script>
import OtherDirectorship from '@/components/reports/panels/directors/OtherDirectorship';
import HseCases from '@/components/reports/panels/HseCases';
import toolsMixin from '@/components/reports/ToolsMixin';

export default {
  components: {
    OtherDirectorship,
    HseCases,
  },
  computed: {
    numberOfActiveOtherDirectorships() {
      let countActive = 0;
      for (let i = 0; i < this.officer.otherappointments.length; i += 1) {
        if (this.officer.otherappointments[i].status === 'open') {
          countActive += 1;
        }
      }

      return countActive;
    },
    openOtherAppointments() {
      return this.officer.otherappointments.filter((a) => a.status === 'open');
    },
  },
  mixins: [toolsMixin],
  props: ['officer', 'report'],
};
</script>
